module.exports = __webpack_public_path__ + "media/images/icon/arrow-round-right-red-73469a969d702dc3446ad3918155d7f2.svg";